module.exports = __webpack_public_path__ + "static/media/element-contact.0ce19fac.png";